export default __webpack_public_path__ + "static/media/Shopify-Storefront---2.42cc08fc.jpg";